export default ({ axios, mapQueryString }) => ({
    index: (group_id, filters = {}) => axios.get(`/branch-groups/${group_id}/properties${mapQueryString(filters)}`),
    show: (group_id, property_id, filters = {}) => axios.get(`/branch-groups/${group_id}/properties/${property_id}${mapQueryString(filters)}`),
    update: (group_id, property_id, body) => axios.patch(`/branch-groups/${group_id}/properties/${property_id}`, body)
})



// WEBPACK FOOTER //
// ./src/api/branchGroupProperties.js